// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .content {
  padding: 0 var(--space-md);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/no-results/no-results.component.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;AAAJ","sourcesContent":[":host {\r\n  .content {\r\n    padding: 0 var(--space-md);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
